// «Для клиента» в проекте (кабинет клиента, часть 10.8): задания клиенту, согласования и прогресс.

/** Вкладка «Для клиента» в карточке проекта (`projects.forClient`). */
export const ruProjectsClient = {
  forClient: {
    tab: 'Для клиента',
    lead: 'Что клиент видит в кабинете: задания ему, работа на согласование и прогресс. Задания и согласования попадают ему в «Нужно от вас», о них приходит письмо',
    hint: {
      title: 'Задания, согласования и прогресс',
      text: 'Задание — клиент присылает материалы или ответы, вы принимаете или возвращаете с комментарием. Согласование — клиент согласует или пишет замечания, вы присылаете новую версию. Прогресс — скриншоты и пара слов о том, что сделано: клиент видит их в ходе работ проекта',
      example:
        'Задание «Пришлите логотип в векторе», согласование «Макет главной», прогресс «Собрали каталог»',
    },
    new: 'Новое',
    newTask: 'Задание клиенту',
    newApproval: 'На согласование',
    newProgress: 'Показать прогресс',
    noClient: 'У проекта нет клиента — давать задания и показывать работу некому',
    emptyTitle: 'Клиенту пока ничего не отправляли',
    emptyText:
      'Дайте задание — например, собрать материалы, — отправьте макет на согласование или покажите, как идёт работа',
    kinds: { task: 'Задание', approval: 'Согласование', progress: 'Прогресс' },
    statuses: {
      open: 'Ждёт клиента',
      submitted: 'Клиент ответил',
      done: 'Принято',
      pending: 'Ждёт согласования',
      approved: 'Согласовано',
      changes: 'Есть замечания',
      published: 'Показано клиенту',
    },
    actions: {
      answer: 'Ответ клиента',
      approve: 'Клиент согласовал',
      changes: 'Замечания клиента',
      accept: 'Принято',
      return: 'Возвращено',
      resend: 'Новая версия',
    },
    dialog: {
      titleTask: 'Задание клиенту',
      titleApproval: 'На согласование',
      titleProgress: 'Прогресс для клиента',
      name: 'Что нужно',
      nameProgress: 'Что сделано',
      namePlaceholderTask: 'Например, пришлите логотип в векторе',
      namePlaceholderApproval: 'Например, макет главной страницы',
      namePlaceholderProgress: 'Например, собрали каталог',
      body: 'Подробнее',
      bodyPlaceholder: 'Что именно и в каком виде — клиент увидит это в кабинете',
      due: 'Срок',
      dueHint: 'Необязательно — клиент увидит срок в «Нужно от вас»',
      files: 'Файлы',
      filesHintApproval: 'Макеты, тексты, PDF — то, что клиенту нужно посмотреть',
      filesHintProgress: 'Скриншоты того, что уже сделано',
      send: 'Отправить клиенту',
      sent: 'Отправлено клиенту',
    },
    due: 'до {date}',
    round: 'Версия {round}',
    by: '{name} · {date}',
    accept: 'Принять',
    returnAction: 'Вернуть',
    resend: 'Новая версия',
    remove: 'Убрать у клиента',
    removed: 'Убрано у клиента',
    comment: 'Комментарий',
    commentReturn: 'Что поправить — клиент увидит это в кабинете',
    commentResend: 'Что изменилось в новой версии',
    send: 'Отправить',
    history: 'История',
  },
} as const;

/** Уведомления сотрудникам (`projects.notifications`). */
export const ruProjectsClientNotifications = {
  clientItem: {
    answer: '{client} ответил на задание «{item}»',
    approve: '{client} согласовал «{item}»',
    changes: '{client} прислал замечания к «{item}»',
  },
} as const;

/** Ошибки `projects.*`. */
export const ruProjectsClientErrors = {
  client_item_not_member: 'Писать клиенту могут участники проекта — попросите руководителя добавить вас',
  client_item_no_client: 'У проекта нет клиента — сначала укажите клиента в «О проекте»',
  client_item_title: 'Напишите, что нужно от клиента',
  client_item_comment: 'Напишите комментарий — что поправить',
  client_item_answer_empty: 'Напишите ответ или приложите файлы',
  client_item_progress_empty: 'Добавьте пояснение или хотя бы один скриншот',
  client_item_action: 'Для этого пункта такое действие не подходит',
  client_item_answered: 'На этот пункт уже ответили — обновите страницу',
  client_item_state: 'Пункт уже в другом состоянии — обновите страницу',
  client_item_files_limit: 'Не больше {max} файлов за раз',
  client_item_file_used: 'Этот файл уже приложен — загрузите его заново',
} as const;

/** «История» проекта. */
export const ruProjectsClientAudit = {
  actions: {
    project: {
      client_item_created: 'Клиенту отправлено',
      client_item_removed: 'Убрано у клиента',
      client_item_restored: 'Возвращено клиенту',
      client_item_accepted: 'Ответ клиента принят',
      client_item_returned: 'Задание возвращено клиенту',
      client_item_resent: 'Новая версия на согласование',
      client_item_answered: 'Клиент ответил на задание',
      client_item_approved: 'Клиент согласовал',
      client_item_changes: 'Клиент прислал замечания',
    },
  },
  fields: {
    item: 'Пункт',
  },
} as const;
